// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"yJ-z","carouselContainer":"zJ-z"};